import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {
  @Input() message: string;
  @Input() badge: string;
  @Input() icon = 'info';

  constructor(
    private readonly domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.message = this.domSanitizer.bypassSecurityTrustHtml(this.message) as string;
  }
}
